// Recovered compiled webpack factory 10798. Edit this function expression; run npm run build.
(e) => {
  e.exports = {
    word: "entrance_word__NZS3g",
    block: "entrance_block__YAC2O",
    arrive: "entrance_arrive__CJgMt",
  };
}
